/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import BackButton from "../../../components/BackButton";
import Card from "../../../components/Card";
import Layout from "../../../layout";
import Cup from "../../../assets/icons/cup.svg";
import CustomButton from "../../../components/CustomButton";
import CustomTextArea from "../../../components/CustomTextArea";
import CustomInput from "../../../components/CustomInput";
import { useHistory, useLocation } from "react-router-dom";
import LeaderList from "./LeaderList";
import cogoToast from "cogo-toast";
import { useDispatch, useSelector } from "react-redux";
import { SectionLoader } from "../../../components/PageLoader";
import {
  Box,
  Grid,
  Paper,
  Typography,
  CardHeader,
  CardContent,
} from "@material-ui/core";

// Accordion replaced with custom implementation for better UX

import pictureLogo from "../../../assets/images/feeds.png";
import { uploadFile } from "../../../utils/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Points from "./Points";
import "./feeds.css";
import {
  createFeedAction,
  getFeedsAction,
  createCommentPostAction,
  deleteFeedsAction,
  deleteCommentAction,
} from "../../../redux/actions/feedAction";
import { useTourGuide } from "../../../hooks/useTourGuide";

const League = () => {
  useTourGuide();
  const { pathname } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMounted = useRef(true);

  const myFormRef = useRef(0);
  const uploadInputRef = useRef(0);
  const [loading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [showComments, setShowComment] = useState(false);
  const [commentValue, setCommentValue] = useState("");
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [commentLoading, setCommentLoading] = useState(false);
  const [expandedPostId, setExpandedPostId] = useState(null);
  const [deletingCommentId, setDeletingCommentId] = useState(null);

  // Use specific selectors to ensure proper re-renders when state changes
  const get_feed_result = useSelector((store) => store.get_feed_result);
  const { userData } = useSelector((store) => store.auth);

  const [stateRecognition, setStateRecognition] = useState({
    content: "",
    img_url: "",
  });

  const [stateComment, setCommentState] = useState({
    feed_id: "",
    content: "",
  });

  // Scroll to top functionality
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    // Set mounted flag
    isMounted.current = true;

    const fetchFeeds = async () => {
      try {
        setLoading(true);
        await getFeedsAction(dispatch, 1);
      } catch (error) {
        console.error("Error fetching feeds:", error);
      } finally {
        if (isMounted.current) {
          setLoading(false);
        }
      }
    };

    fetchFeeds();

    // Cleanup function
    return () => {
      isMounted.current = false;
    };
  }, [dispatch]);

  const handleChangeUpload = ({ target: { files } }) => {
    if (files && files[0]) {
      setIsUploading(true);

      Promise.resolve(
        uploadFile(
          files[0],
          "https://api.cloudinary.com/v1_1/workbrook-hash/raw/upload"
        )
      )
        .then(({ data, success }) => {
          if (success) {
            //addDocLink(data);
            setStateRecognition({ ...stateRecognition, img_url: data });
            // addDocLinkObject({ link: data, name: files[0].name });
          } else {
            cogoToast.error("Unsuccessful document upload", {
              hideAfter: 4,
              position: "top-center",
            });
          }
        })
        .finally(() => {
          setIsUploading(false);
        });
    }
  };

  const handleChange = ({ target: { id, value, checked } }) => {
    setStateRecognition((prevState) => ({ ...prevState, [id]: value }));
  };

  const handleChangeComment = ({ target: { id, value, checked } }) => {
    setCommentState((prevState) => ({ ...prevState, [id]: value }));
  };

  const handleRefClick = () => {
    uploadInputRef.current.click();
  };

  const handleSubmitComment = async (e, feedId) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Prevent double submission
    if (commentLoading) return;
    
    if (!stateComment.content.trim()) {
      cogoToast.error("Please enter a comment", {
        hideAfter: 3,
        position: "top-center",
      });
      return;
    }

    try {
      setCommentLoading(true);
      const actualFeedId = feedId || stateComment.feed_id;
      
      const response = await createCommentPostAction(dispatch, {
        ...stateComment,
        feed_id: actualFeedId,
        // Include user data so comment displays immediately
        commented_by_user: userData ? {
          id: userData.id,
          first_name: userData.first_name,
          last_name: userData.last_name,
          image_url: userData.image_url,
          title: userData.title,
        } : null,
      });

      if (response?.success && isMounted.current) {
        setCommentState({
          feed_id: "",
          content: "",
        });

        // Keep comments section expanded after adding comment
        setExpandedPostId(actualFeedId);
        // Note: Toast is shown automatically by response interceptor
      }
    } catch (error) {
      if (isMounted.current) {
        console.error("Error adding comment:", error);
        // Note: Error toast is shown automatically by response interceptor
      }
    } finally {
      if (isMounted.current) {
        setCommentLoading(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stateRecognition.content.trim()) {
      cogoToast.error("Please enter some content for your post", {
        hideAfter: 3,
        position: "top-center",
      });
      return;
    }

    try {
      if (isMounted.current) {
        setLoading(true);
      }

      const response = await createFeedAction(dispatch, {
        ...stateRecognition,
      });

      if (response?.success && isMounted.current) {
        setStateRecognition({
          content: "",
          img_url: "",
        });

        // Refresh feeds after successful post
        await getFeedsAction(dispatch, 1);
        // Note: Toast is shown automatically by response interceptor
      }
    } catch (error) {
      if (isMounted.current) {
        console.error("Error creating feed:", error);
        // Note: Error toast is shown automatically by response interceptor
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  const [deletingFeedId, setDeletingFeedId] = useState(null);

  const deleteFeedSubmit = async (_id) => {
    if (deletingFeedId) return; // Prevent double deletion
    
    try {
      setDeletingFeedId(_id);
      await deleteFeedsAction(dispatch, {
        item_id: _id,
      });
      // Note: Toast is shown automatically by response interceptor
    } catch (error) {
      if (isMounted.current) {
        console.error("Error deleting feed:", error);
        // Note: Error toast is shown automatically by response interceptor
      }
    } finally {
      if (isMounted.current) {
        setDeletingFeedId(null);
      }
    }
  };
  
  const deleteCommentSubmit = async (commentId, feedId) => {
    if (deletingCommentId) return; // Prevent double deletion
    
    try {
      setDeletingCommentId(commentId);
      const response = await deleteCommentAction(dispatch, {
        comment_id: commentId,
        feed_id: feedId,
      });

      if (response?.success && isMounted.current) {
        // Keep accordion expanded after deleting comment
        setExpandedPostId(feedId);
        // Note: Toast is shown automatically by response interceptor
      }
    } catch (error) {
      if (isMounted.current) {
        console.error("Error deleting comment:", error);
        // Note: Error toast is shown automatically by response interceptor
      }
    } finally {
      if (isMounted.current) {
        setDeletingCommentId(null);
      }
    }
  };

  const displayData = () => {
    if (pathname.includes("list")) {
      return <LeaderList />;
    } else if (pathname.includes("point")) {
      return <Points />;
    } else {
      return (
        <div className="w-100 d-flex pt-5 flex-column">
          <div className="col-md-10 gedf-main" style={{ marginLeft: "10%" }}>
            <form onSubmit={handleSubmit}>
              <div className="card gedf-card">
                <div className="card-body">
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="posts"
                      role="tabpanel"
                      aria-labelledby="posts-tab"
                    >
                      <div className="form-group">
                        <label className="sr-only" htmlFor="message">
                          post
                        </label>

                        <CustomTextArea
                          placeholder="Post a content..."
                          onChange={handleChange}
                          value={stateRecognition.content}
                          name="content"
                          id="content"
                        />
                      </div>
                    </div>

                    <div>
                      <input
                        ref={uploadInputRef}
                        type="file"
                        onChange={handleChangeUpload}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>

                  <div className="btn-toolbar justify-content-between">
                    <div className="btn-group">
                      <button
                        className="btn mgtr btn-default"
                        type="button"
                        onClick={handleRefClick}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <img src={pictureLogo} className="post-div-logo" />
                          </Grid>

                          <Grid item xs={6}>
                            <img
                              src={stateRecognition.img_url}
                              className="post-div-logo-result"
                            />
                          </Grid>
                        </Grid>
                      </button>
                    </div>
                    <button
                      type="submit"
                      className="btn  

             btn-primary blue-button pull-right"
                    >
                      Post
                    </button>

                    {/* <div className="btn-group">
                <button id="btnGroupDrop1" type="button" className="btn btn-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    <i className="fa fa-globe"></i>
                </button>
                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDrop1">
                    <a className="dropdown-item" href="#"><i className="fa fa-globe"></i> Public</a>
                    <a className="dropdown-item" href="#"><i className="fa fa-users"></i> Friends</a>
                    <a className="dropdown-item" href="#"><i className="fa fa-user"></i> Just me</a>
                </div> 
            </div>
            */}
                  </div>
                </div>
              </div>
            </form>
            {loading && <SectionLoader />}

            {get_feed_result &&
              Array.isArray(get_feed_result.get_feed_result) &&
              get_feed_result.get_feed_result.map((item, index) => {
                const feedUser = item.user?.[0] || {};
                return (
                  <div className="card gedf-card" key={item.id || index}>
                    <div className="card-header">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="mr-2">
                            <img
                              className="rounded-circle"
                              width="45"
                              src={feedUser.image_url || "https://res.cloudinary.com/workbrook-hash/image/upload/v1587164870/App/user-circle-02_jbpaez.png"}
                              alt=""
                            />
                          </div>
                          <div className="ml-2">
                            <div className="h5 m-0">
                              @{feedUser.last_name || ""}
                              {feedUser.first_name || ""}
                            </div>
                            <div className="h7 text-muted">
                              {feedUser.title || ""}
                            </div>
                          </div>
                        </div>
                        {/* Only show delete button for user's own posts */}
                        {userData?.id && feedUser.user_id == userData.id && (
                          <button
                            type="button"
                            onClick={() => deleteFeedSubmit(item.id)}
                            disabled={deletingFeedId === item.id}
                            style={{
                              padding: "6px 10px",
                              backgroundColor: "transparent",
                              border: "1px solid #dc3545",
                              borderRadius: "6px",
                              cursor: deletingFeedId === item.id ? "not-allowed" : "pointer",
                              opacity: deletingFeedId === item.id ? 0.5 : 1,
                              color: "#dc3545",
                              transition: "all 0.2s ease",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              fontSize: "13px",
                            }}
                            title="Delete post"
                            onMouseEnter={(e) => {
                              if (deletingFeedId !== item.id) {
                                e.currentTarget.style.backgroundColor = "#dc3545";
                                e.currentTarget.style.color = "#fff";
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = "transparent";
                              e.currentTarget.style.color = "#dc3545";
                            }}
                          >
                            {deletingFeedId === item.id ? (
                              "Deleting..."
                            ) : (
                              <>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <polyline points="3 6 5 6 21 6"></polyline>
                                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                </svg>
                                Delete
                              </>
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="text-muted h7 mb-2">
                        {" "}
                        <i className="fa fa-clock-o"></i>
                        {item.created_at}
                      </div>

                      <p className="card-text">{item.content}</p>
                      <img src={item.img_url} style={{ width: "30%" }} />
                    </div>
                    <div className="card-footer" style={{ padding: 0, border: "none", backgroundColor: "transparent" }}>
                      {/* Comments Toggle Button */}
                      <button
                        type="button"
                        onClick={() => setExpandedPostId(expandedPostId === item.id ? null : item.id)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          backgroundColor: expandedPostId === item.id ? "#f8f9fa" : "#fff",
                          border: "none",
                          borderTop: "1px solid #eee",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          transition: "background-color 0.2s ease",
                        }}
                      >
                        <span style={{ display: "flex", alignItems: "center", gap: "10px", color: "#333", fontWeight: "500" }}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3A6ED4" strokeWidth="2">
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                          </svg>
                          Comments
                          {item.comments && item.comments.length > 0 && (
                            <span
                              style={{
                                backgroundColor: "#3A6ED4",
                                color: "#fff",
                                borderRadius: "12px",
                                padding: "2px 10px",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}
                            >
                              {item.comments.length}
                            </span>
                          )}
                        </span>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#666"
                          strokeWidth="2"
                          style={{
                            transform: expandedPostId === item.id ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.2s ease",
                          }}
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </button>

                      {/* Comments Panel */}
                      {expandedPostId === item.id && (
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "16px",
                            borderTop: "1px solid #eee",
                          }}
                        >
                          {/* Comment Input Form */}
                          <form
                            onSubmit={(e) => handleSubmitComment(e, item.id)}
                            style={{
                              display: "flex",
                              gap: "10px",
                              marginBottom: item.comments && item.comments.length > 0 ? "16px" : "0",
                            }}
                          >
                            <input
                              type="text"
                              onChange={({ target: { value } }) => {
                                setCommentState({
                                  ...stateComment,
                                  feed_id: item.id,
                                  content: value,
                                });
                              }}
                              value={stateComment.feed_id === item.id ? stateComment.content : ""}
                              placeholder="Write a comment..."
                              disabled={commentLoading}
                              style={{
                                flex: 1,
                                padding: "10px 14px",
                                border: "1px solid #ddd",
                                borderRadius: "20px",
                                fontSize: "14px",
                                outline: "none",
                                backgroundColor: "#fff",
                              }}
                            />
                            <button
                              type="submit"
                              disabled={commentLoading || !(stateComment.feed_id === item.id && stateComment.content.trim())}
                              style={{
                                padding: "10px 20px",
                                backgroundColor: commentLoading ? "#ccc" : "#3A6ED4",
                                color: "#fff",
                                border: "none",
                                borderRadius: "20px",
                                cursor: commentLoading ? "not-allowed" : "pointer",
                                fontSize: "14px",
                                fontWeight: "500",
                                transition: "background-color 0.2s ease",
                                opacity: (commentLoading || !(stateComment.feed_id === item.id && stateComment.content.trim())) ? 0.6 : 1,
                              }}
                            >
                              {commentLoading ? "Posting..." : "Post"}
                            </button>
                          </form>

                          {/* Comments List */}
                          {item.comments && item.comments.length > 0 && (
                            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                              {item.comments.map((comment, commentIndex) => (
                                <div
                                  key={comment.id || commentIndex}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "12px",
                                    padding: "12px",
                                    backgroundColor: "#fff",
                                    borderRadius: "12px",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                  }}
                                >
                                  <img
                                    src={
                                      comment.commented_by_user?.image_url ||
                                      "https://res.cloudinary.com/workbrook-hash/image/upload/v1587164870/App/user-circle-02_jbpaez.png"
                                    }
                                    alt=""
                                    style={{
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
                                      <span style={{ fontWeight: "600", fontSize: "13px", color: "#333" }}>
                                        {comment.commented_by_user?.first_name || "Unknown"}{" "}
                                        {comment.commented_by_user?.last_name || ""}
                                      </span>
                                    </div>
                                    <p style={{ margin: 0, fontSize: "14px", color: "#444", lineHeight: "1.4", wordBreak: "break-word" }}>
                                      {comment.content}
                                    </p>
                                  </div>
                                  {/* Only show delete button for user's own comments */}
                                  {userData?.id && comment.commented_by_user_id == userData.id && (
                                    <button
                                      type="button"
                                      onClick={() => deleteCommentSubmit(comment.id, item.id)}
                                      disabled={deletingCommentId === comment.id}
                                      style={{
                                        padding: "6px",
                                        backgroundColor: "transparent",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: deletingCommentId === comment.id ? "not-allowed" : "pointer",
                                        opacity: deletingCommentId === comment.id ? 0.5 : 1,
                                        color: "#999",
                                        transition: "color 0.2s ease, background-color 0.2s ease",
                                      }}
                                      title="Delete comment"
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.color = "#dc3545";
                                        e.currentTarget.style.backgroundColor = "#fee";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.color = "#999";
                                        e.currentTarget.style.backgroundColor = "transparent";
                                      }}
                                    >
                                      {deletingCommentId === comment.id ? (
                                        <span style={{ fontSize: "12px" }}>...</span>
                                      ) : (
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                          <polyline points="3 6 5 6 21 6"></polyline>
                                          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                        </svg>
                                      )}
                                    </button>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}

                          {/* Empty State */}
                          {(!item.comments || item.comments.length === 0) && (
                            <p style={{ textAlign: "center", color: "#888", margin: "10px 0 0 0", fontSize: "14px" }}>
                              No comments yet. Be the first to comment!
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}

            {/*
 <div className="card gedf-card">
    <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-between align-items-center">
                <div className="mr-2">
                    <img className="rounded-circle" width="45" src="https://picsum.photos/50/50" alt="" />
                </div>
                <div className="ml-2">
                    <div className="h5 m-0">@LeeCross</div>
                    <div className="h7 text-muted">Miracles Lee Cross</div>
                </div>
            </div>
            <div>
                <div className="dropdown">
                    <button className="btn btn-link dropdown-toggle" type="button" id="gedf-drop1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fa fa-ellipsis-h"></i>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="gedf-drop1">
                        <div className="h6 dropdown-header">Configuration</div>
                        <a className="dropdown-item" href="#">Save</a>
                        <a className="dropdown-item" href="#">Hide</a>
                        <a className="dropdown-item" href="#">Report</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div className="card-body">
        <div className="text-muted h7 mb-2"> <i className="fa fa-clock-o"></i> 10 min ago</div>
        <a className="card-link" href="#">
            <h5 className="card-title"> Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit consectetur
                deserunt illo esse distinctio.</h5>
        </a>

        <p className="card-text">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam omnis nihil, aliquam est, voluptates officiis iure soluta
            alias vel odit, placeat reiciendis ut libero! Quas aliquid natus cumque quae repellendus. Lorem
            ipsum dolor sit amet consectetur adipisicing elit. Ipsa, excepturi. Doloremque, reprehenderit!
            Quos in maiores, soluta doloremque molestiae reiciendis libero expedita assumenda fuga quae.
            Consectetur id molestias itaque facere? Hic!
        </p>
        <div>
        
        </div>
    </div>
    <div className="card-footer">
        <a href="#" className="card-link"><i className="fa fa-gittip"></i> Like</a>
         <a href="#" className="card-link"><i className="fa fa-mail-forward"></i> Comment</a>
    </div>
</div>
 

 <div className="card gedf-card">
    <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-between align-items-center">
                <div className="mr-2">
                    <img className="rounded-circle" width="45" src="https://picsum.photos/50/50" alt=""/>
                </div>
                <div className="ml-2">
                    <div className="h5 m-0">@LeeCross</div>
                    <div className="h7 text-muted">Miracles Lee Cross</div>
                </div>
            </div>
            <div>
                <div className="dropdown">
                    <button className="btn btn-link dropdown-toggle" type="button" id="gedf-drop1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fa fa-ellipsis-h"></i>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="gedf-drop1">
                        <div className="h6 dropdown-header">Configuration</div>
                        <a className="dropdown-item" href="#">Save</a>
                        <a className="dropdown-item" href="#">Hide</a>
                        <a className="dropdown-item" href="#">Report</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div className="card-body">
        <div className="text-muted h7 mb-2"> <i className="fa fa-clock-o"></i> Hace 40 min</div>
        <a className="card-link" href="#">
            <h5 className="card-title">Totam non adipisci hic! Possimus ducimus amet, dolores illo ipsum quos
                cum.</h5>
        </a>

        <p className="card-text">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam sunt fugit reprehenderit consectetur exercitationem odio,
            quam nobis? Officiis, similique, harum voluptate, facilis voluptas pariatur dolorum tempora sapiente
            eius maxime quaerat.
            <a href="https://mega.nz/#!1J01nRIb!lMZ4B_DR2UWi9SRQK5TTzU1PmQpDtbZkMZjAIbv97hU" target="_blank">https://mega.nz/#!1J01nRIb!lMZ4B_DR2UWi9SRQK5TTzU1PmQpDtbZkMZjAIbv97hU</a>
        </p>
    </div>
    <div className="card-footer">
        <a href="#" className="card-link"><i className="fa fa-gittip"></i> Like</a>
         <a href="#" className="card-link"><i className="fa fa-mail-forward"></i> Comment</a>
    </div>
</div>
 
*/}
          </div>

          {/* 
          <img className="d-block mx-auto mt-5" src={Cup} alt="cup" />
          <h5 className="text-center my-5">
            How you earn points in the WB League
          </h5>
          <ul className="d-flex co-gray w-100 flex-column align-items-center justify-content-center">
            <li className="my-1">
              Earn points by completing tasks on the app.
            </li>
            <li className="my-1">Complete your profile to 100%.</li>
            <li className="my-1">Make a successful referral.</li>
            <li className="my-1">Invite a friend to use workbrook.</li>
            <li className="my-1">Convert your earned points to real money.</li>  
          </ul>
          <h5 className="co-primary text-center my-5">
            Complete Your Profile (5pts)
          </h5>

          <div className="w-75 my-3 mx-auto">
            <CustomButton
              handleClick={() => history.push("/league/points")}
              backgroundColor="#3A6ED4"
              color="#fff"
              text="Take me to WB Points"
              additionalClass="my-3"
            />
          </div>  
        */}
        </div>
      );
    }
  };

  return (
    <Layout>
      <BackButton />

      <div className="mx-4x pb-4z">{displayData()}</div>

      {/* Scroll to Top Button */}
      {showScrollButton && (
        <button
          onClick={handleScrollToTop}
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#3A6ED4",
            color: "white",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
            zIndex: 1000,
            transition: "all 0.3s ease",
          }}
          className="scroll-to-top-button"
          aria-label="Scroll to top"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 15l-6-6-6 6" />
          </svg>
        </button>
      )}
    </Layout>
  );
};

export default League;
